// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Tabs-module--bx--text-truncate--end--15Y6E";
export var bxTextTruncateFront = "Tabs-module--bx--text-truncate--front--3ZkXG";
export var dropdownWrapper = "Tabs-module--dropdownWrapper--19Otq";
export var panel = "Tabs-module--panel--27NIe";
export var tab = "Tabs-module--tab--QLds1";
export var tabList = "Tabs-module--tab-list--2RI9Y";